// extracted by mini-css-extract-plugin
export default {"button":"qp-z","reviewSort":"rp-z"};